import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Datasheet from "react-datasheet";
import { Button } from "antd";
import { 
    OrderedMap,
    Map, 
    List
} from "immutable";
import shortID from "uuid/v4";
import {
    ObjectSelectEditor
} from "components";
import { UI_LIST_ITEM_TYPES } from "constants";
import { FEE_CALCULATION_TYPES, PRODUCT_FEE_TYPES, FEE_DEBIT_AT_TYPES, BOOLEAN_OPTIONS } from "constants/enums";
import { BusinessProgramFacilityDetailRecord } from "records/schemes-record";

// const valueRenderer = (_, key, type) => {
//     return _ && (type && _[key] ? _[key].toFixed(2) : _[key]);
// };

const BUSINESS_FEE_DETAIL_FIELDS = () => new OrderedMap({
    labels: {
        label: "Schemes",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM_HEADER
    },
    fee_type: {
        label: "FEE_TYPE",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
        dataType: "OBJECT_SELECT",
        options: PRODUCT_FEE_TYPES,
        component: (() => {
            const comp = props => (
                <ObjectSelectEditor
                    options={PRODUCT_FEE_TYPES.map((_, k) => ({
                        label: k,
                        value: _
                    })).toList()}
                    // mode={"multiple"}
                    style={
                        {width: "100%"}
                    }
                    labelProp={"label"}
                    {...props}
                />);
            comp.displayName= "DataSheetSelectEditor";
            return comp;
        })()
    },
    limit_range_start: {
        label: "Limit Range Start",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
        dataType: "FLOAT",
        isFloat: false,
    },
    limit_range_end: {
        label: "Limit Range End",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
        dataType: "INTEGER",
        isFloat: false
    },
    fee_calculation_type: {
        label: "Fee Calculation Type",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
        dataType: "OBJECT_SELECT",
        options: FEE_CALCULATION_TYPES,
        component: (() => {
            const comp = props => (
                <ObjectSelectEditor
                    options={FEE_CALCULATION_TYPES.map((_, k) => ({
                        label: k,
                        value: _
                    })).toList()}
                    // mode={"multiple"}
                    style={
                        {width: "100%"}
                    }
                    labelProp={"label"}
                    {...props}
                />);
            comp.displayName= "DataSheetSelectEditor";
            return comp;
        })()
    },
    amount_or_percentage: {
        label: "Fee Value",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
        dataType: "FLOAT",
        isFloat: true
    },
    fee_debit_at: {
        label: "Fee Debit At",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
        dataType: "OBJECT_SELECT",
        options: FEE_DEBIT_AT_TYPES,
        component: (() => {
            const comp = props => (
                <ObjectSelectEditor
                    options={FEE_DEBIT_AT_TYPES.map((_, k) => ({
                        label: k,
                        value: _
                    })).toList()}
                    mode={"multiple"}
                    style={
                        {width: "100%"}
                    }
                    labelProp={"label"}
                    {...props}
                />);
            comp.displayName= "DataSheetSelectEditor";
            return comp;
        })()
    },
    select: {
        label: "Select Entries",
        type: UI_LIST_ITEM_TYPES.SELECT,
        dataType: "OBJECT_SELECT",
        options: BOOLEAN_OPTIONS,
        component: (() => {
            const comp = props => (
                <ObjectSelectEditor
                    options={BOOLEAN_OPTIONS.map((_, k) => ({
                        label: k,
                        value: _
                    })).toList()}
                    // mode={"multiple"}
                    style={
                        {width: "100%"}
                    }
                    labelProp={"label"}
                    {...props}
                />);
            comp.displayName= "DataSheetSelectEditor";
            return comp;
        })()
    }
});


class BussinessProgramFeeForm extends React.Component{
    state = {
        masterProgramData: [],
        distributorProgramData: [],
        facility_details: new List([]),
        mpaIds: new Map({}),
        dpaIds: new Map({}),
        removed_ids: [],
    }

    getState() {
        const state = {};
        if(
            !this.props.parentProgramData &&
            this.props.values && 
            this.props.values.size && 
            this.props.values.first() && 
            this.props.values.first().get("id")
        ) {
            state.facility_details = this.props.values;
            state.mpaIds = this.props.values.map((v,k) => k);
        } else if(this.props.parentProgramData && this.props.parentProgramData.size) {
            state.facility_details = this.props.parentProgramData;
            state.mpaIds = this.props.parentProgramData.map((v,k) => k);
            state.dpaIds = this.props.parentProgramData.map((v,k) => k);
        } else {
            const newID = shortID();
            state.mpaIds = new Map({newID});
            state.facility_details = new List([new BusinessProgramFacilityDetailRecord()]);
        }
        return state;
    }

    edit = true;
    fields = null;
    
    generateFacilityRows(isMPA) {
        this.fields = BUSINESS_FEE_DETAIL_FIELDS();
        this.fields = isMPA ? this.fields.filter(_ => _.label !== "Select Entries") : this.fields;
        let grid_header = this.fields.map((_, k) => {
            if (_.type === UI_LIST_ITEM_TYPES.SECTION) {
                return [
                    {
                        value: _.label,
                        readOnly: true,
                        itemKey: k,
                        type: _.type,
                        colSpan: this.fields && this.fields.size
                    }
                ];
            }
            return ({
                value: _.label,
                readOnly: true,
                colSpan: 1,
                type: _.type,
                itemKey: k
            });
        }).toList().toArray();

        let grid_content = this.state.mpaIds.map(_ => (
            [
                {
                    value: isMPA ? "Master Program" : "Distributor Program",
                    readOnly: true,
                    type: "LIST_ITEM_HEADER"
                },
                ...this.fields.filter(_ => !["SECTION", "LIST_ITEM_HEADER"].includes(_.type)).map((__, k) => {
                    return ({
                        value: this.props.values && this.props.values.get(_) ? 
                            __.options ?
                                typeof this.props.values.get(_)[k] === "object" && this.props.values.get(_)[k].length > 0 ?
                                    __.options.findKey(v => v === this.props.values.get(_)[k][0]) :
                                    __.options.findKey(v => v === this.props.values.get(_)[k]) :
                                this.props.values.get(_)[k] 
                            : __.value,
                        itemKey: `${_}|${k}`,
                        type: __.type,
                        dataType: __.dataType,
                        readOnly: this.props.parentProgramData && isMPA ? true : false,
                        dataEditor: __.component
                    });
                }).toList().toArray()
            ]
        )).toList().toArray();

        let grid_data = [grid_header, ...grid_content];
        return grid_data;
    }

    componentDidMount() {
        this.edit = true;
        // this.fields
        this.setState({
            ...this.getState(),
            
        }, () => this.setState({
            // data: this.generateCols()
            masterProgramData: this.generateFacilityRows(true),
            distributorProgramData: this.props.parentProgramData && this.props.values ? this.generateFacilityRows(false) : []
        }));
    }

    cellRenderer = (cell) => {
        if(cell && cell.dataType === "SELECT") {
            return cell.value ? cell.options.findKey(_ => _ === cell.value) : "";
        }
        if(cell && cell.dataType === "OBJECT_SELECT" && cell.value && (cell.value.name || cell.value.label )) {
            return cell.value ? (cell.value.name ? cell.value.name : cell.value.label) : "";
        }

        if(cell && cell.dataType === "OBJECT_SELECT" && cell.value && typeof cell.value !== "string" && cell.value.length > 0) {
            return cell.value ? (cell.value.map(_ => _.name ? _.name : _.label).join("; ")) : "";
        }

        if(cell.value && cell.value._isAMomentObject) {
            return cell.value.format("DD-MM-YYYY");
        }

        if(cell.value && isNaN(cell.value)) {
            return cell.value;
        }
        if(!cell.value) {
            return "--";
        }
        return cell.value;
    }

    toggleFormGrid = (action = "ADD", id) => {
        const { mpaIds } = this.state;
        let removed_ids = this.state.removed_ids;
        const newID = shortID();
        switch (action) {
        case "ADD":
            this.setState({
                mpaIds: mpaIds.set(newID, newID)
            }, () => {
                this.setState({
                    masterProgramData: this.generateFacilityRows(true)
                });
            });
            break;
        case "REMOVE": {
            removed_ids.push(id);
            this.setState({
                removed_ids: removed_ids
            }, () => {
                this.props.deleteFacilityDetails(id);
            });
            break;
        }
        default:
        }
    };

    saveFeeDetails = () => {
        const obj = {};
        let data = this.state.masterProgramData;
        if(this.state.distributorProgramData && this.state.distributorProgramData.length > 0 && this.props.parentProgramData && this.props.parentProgramData.id) {
            data = this.state.distributorProgramData.splice(1,this.state.distributorProgramData.length);
        }
        else {
            data = this.state.masterProgramData.splice(1,this.state.masterProgramData.length);      
        }

        data.map((_, key) => {
            _.filter(__ => __.type === UI_LIST_ITEM_TYPES.LIST_ITEM)
                .map((v) => {
                    obj[key] = {
                        ...obj[key],
                        [v.itemKey.split("|")[1]] : typeof v.value === "object" ? 
                            (v.value.length > 0  ? v.value.map(__ => (__.value || __.id)) : v.value["value"] ? v.value["value"] : v.value["id"]) :                   
                            v.value === "" ? 0 : 
                                typeof v.value === "string" ? 
                                    v.value : Number(v.value)
                    };
                    
                });
        });

        let newObj = new Map(obj).map(_ => ({
            ..._,
            business_program: this.props.businessProgramId
        })).toList().toJS();
        this.props.saveFeeDetails(newObj);
    }

    render() {
        return (
            <React.Fragment>
                {!this.props.parentProgramData ? <div className={cx("mb-10 mr-10 w-100")}>
                    <Button
                        type="primary"
                        icon={"plus"}
                        onClick={this.toggleFormGrid.bind(null, "ADD")}>
                        Add New
                    </Button>
                </div> : null}
                <div className={"m-5 spreadsheet-table"}>
                    <Datasheet
                        data={this.state.masterProgramData}
                        valueRenderer={cell =>
                            this.cellRenderer(cell)
                        }
                        onCellsChanged={changes => {
                            this.edit = true;
                            this.saveActive = true;
                            const grid = this.state.masterProgramData.map(row => [...row]);
                            changes.forEach(({ row, col, value }) => {
                                let error = false;
                                // if (
                                //     value &&
                                //     value.length > 0 &&
                                //     isNaN(Number(value))
                                // ) {
                                //     error = true;
                                //     this.saveActive = false;
                                // }
                                grid[row][col] = {
                                    ...grid[row][col],
                                    value,
                                    className: error ? "error-cell" : null
                                };
                            });
                            this.setState({ masterProgramData: grid });
                        }}
                    />  
                </div>
                {this.props.parentProgramData && this.props.parentProgramData.size ? <div className={"m-5 spreadsheet-table"}>
                    <Datasheet
                        data={this.state.distributorProgramData}
                        valueRenderer={cell =>
                            this.cellRenderer(cell)
                        }
                        onCellsChanged={changes => {
                            this.edit = true;
                            this.saveActive = true;
                            const grid = this.state.distributorProgramData.map(row => [...row]);
                            changes.forEach(({ row, col, value }) => {
                                let error = false;
                                // if (
                                //     value &&
                                //     value.length > 0 &&
                                //     isNaN(Number(value))
                                // ) {
                                //     error = true;
                                //     this.saveActive = false;
                                // }
                                grid[row][col] = {
                                    ...grid[row][col],
                                    value,
                                    className: error ? "error-cell" : null
                                };
                            });
                            this.setState({ distributorProgramData: grid });
                        }}
                    />  
                </div> : null}
                <div className="d-flex justify-content-flex-end mr-5" style={{paddingTop: "5px"}}>
                    <Button key="save" type="primary" icon={"plus"} onClick={this.saveFeeDetails}>{this.props.values && this.props.values.get("id") ? "Update" : "Save"}</Button>
                </div>
            </React.Fragment>
        );
    }
}

BussinessProgramFeeForm.propTypes = {
    values: PropTypes.object,
    saveFeeDetails: PropTypes.func,
    businessProgramId: PropTypes.number,
    parentProgramData: PropTypes.object,
    deleteFacilityDetails: PropTypes.func

};

export default BussinessProgramFeeForm;